import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';

import type { SinglePiece } from '../../types';
import Loader from '../loaders/LoaderSpinner';
import { InfiniteScrollListElement } from './InfiniteScrollListElement';

interface InfinitePieceListProps {
  data: SinglePiece[];
  loadMore: () => void;
  hasMore: boolean;
  handleClick: (campaignId: string, influencerId: string) => void;
  hasPublicationDate?: boolean;
}

export const InfinitePieceList = ({
  data,
  loadMore,
  hasMore,
  handleClick,
  hasPublicationDate,
}: InfinitePieceListProps) => {
  const { t } = useTranslation('common');
  return (
    <InfiniteScroll
      dataLength={data.length}
      next={loadMore}
      hasMore={hasMore}
      loader={
        <div className="w-full flex overflow-hidden items-center justify-center mt-2">
          <Loader />
        </div>
      }
      endMessage={
        <p className="text-center mt-2">
          <b>{t('controlView.endResults')}</b>
        </p>
      }
    >
      {data.map((d, i) => (
        <div key={i} className="py-0.5">
          <InfiniteScrollListElement
            key={d.campaign_id + d.influencer_id + i}
            {...d}
            onClick={() => handleClick(d.campaign_id, d.influencer_id)}
            hasPublicationDate={hasPublicationDate}
          />
        </div>
      ))}
    </InfiniteScroll>
  );
};
